/**
 * ClientCalendarHeader Component
 * Simple header for client portal calendar (view-only)
 */

import React from 'react';

const ClientCalendarHeader = () => {
  return (
    <div className="client-calendar-header">
      <h1 className="title gray-800 mb-0">Calendar</h1>
    </div>
  );
};

export default React.memo(ClientCalendarHeader);
